import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	viewAllProjectsLabel: {
		id: 'spa-apps-sidebar-core.multi-project-menu.project-group.view-all-projects.view-all-projects-label',
		defaultMessage: 'View all projects',
		description: 'The label for the view all projects button.',
	},
});
